import React from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";

import Interassignment from "./interassignment";
import Intraassignment from "./intraassignment";

import Dailyshift from "./dailyshift";

function Shiftassignment() {
  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("daily");
  const [heading, setHeading] = useState("DAILY");
  const [selctedoption,setselectedOptions]=useState("");
  const [searchval,setSearchVal]=useState("");

  // useEffect(() => {
  //   const tab = location.state?.tab || "daily";
  //   setActiveTab(tab);
  // }, [location.state?.tab]);

  useEffect(() => {
    const tab = location.state?.tab || "daily";
    const selectedOption = location.state?.selval || "";
    const searchValue = location.state?.searchVal || "";
    if(tab=="daily"){
      setHeading("DAILY");
    }
    else if(tab=="inter"){
      setHeading("INTER");
    }
    else if(tab=="intra"){
      setHeading("INTRA");
    }
    else{
      setHeading("");
    }

    console.log("selectedOption12:",selectedOption);
    console.log("searchValue12:",searchValue);
    console.log("tab",tab);
    

    setActiveTab(tab);
    setselectedOptions(selectedOption);
    setSearchVal(searchValue);

  }, [location.state]);


  const changeNormal = () => {
    setHeading("DAILY");
  };
  const changeInterassign = () => {
    setHeading("INTER");
  };
  const changeIntraassign = () => {
    setHeading("INTRA");
  };
 
const selectedOptions = location.state?.selval || "";
    const searchValues = location.state?.searchVal || "";
  return (
    <div>
      <Topnavbar />

      <Sidennav />
      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">
            {/* /# row */}
            <section id="main-content">
              <div class="card">
                <div class="card-header" style={{ color: "black" }}>
                  <h6 class="card-title"> {heading } SHIFT ASSIGNMENT </h6>
                  <div className="d-flex align-items-center">
                    

                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <button
                        style={{ cursor: "pointer" }}
                          className={`nav-link ${
                            activeTab === "daily" ? "active" : ""
                          }`}
                          onClick={() => {
                            setActiveTab("daily");
                            changeNormal();
                          }}
                        >
                          Daily Shift
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                         style={{ cursor: "pointer" }}
                          className={`nav-link ${
                            activeTab === "inter" ? "active" : ""
                          }`}
                          onClick={() => {
                            setActiveTab("inter");
                            changeInterassign();
                          }}
                        >
                          Inter Shift
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                         style={{ cursor: "pointer" }}
                          className={`nav-link ${
                            activeTab === "intra" ? "active" : ""
                          }`}
                          onClick={() => {
                            setActiveTab("intra");
                            changeIntraassign();
                          }}
                        >
                          Intra Shift
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    
                    {activeTab === "daily" && (
                      <div id="dailyassignment">
                        <Dailyshift onBack={() => setActiveTab("daily")} />
                      </div>
                    )}
                    {activeTab === "inter" && (
                      <div id="interassignment">
                        <Interassignment selectedOption={selectedOptions} searchValue={searchValues} onBack={() => setActiveTab("inter")} />
                      </div>
                    )}

                    {activeTab === "intra" && (
                      <div id="intraassignment">
                        <Intraassignment selectedOption={selectedOptions} searchValue={searchValues}  onBack={() => setActiveTab("intra")} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* /# column */}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shiftassignment;
